// types
import { SystemProcessConditionAction } from 'types/graphql'

export enum TransactionName {
  AuthMethod = 'authMethod',
  BusinessUnit = 'businessUnitId',
  JobTitle = 'jobTitle'
}

export const PROPERTIES_OPTIONS = [
  { label: 'Business Unit', value: TransactionName.BusinessUnit },
  {
    label: 'Authentication Method',
    value: TransactionName.AuthMethod
  }
]

export const CONDITION_FIELD_OPTIONS = [{ label: 'Email', value: 'EMAIL' }]

export const JOB_TITLE_OPTIONS = [
  { label: 'Attribute 1', value: 'extensionAttribute1' },
  { label: 'Attribute 2', value: 'extensionAttribute2' },
  { label: 'Attribute 3', value: 'extensionAttribute3' },
  { label: 'Attribute 4', value: 'extensionAttribute4' },
  { label: 'Attribute 5', value: 'extensionAttribute5' },
  { label: 'Attribute 6', value: 'extensionAttribute6' },
  { label: 'Attribute 7', value: 'extensionAttribute7' },
  { label: 'Attribute 8', value: 'extensionAttribute8' },
  { label: 'Attribute 9', value: 'extensionAttribute9' },
  { label: 'Attribute 10', value: 'extensionAttribute10' },
  { label: 'Attribute 11', value: 'extensionAttribute11' },
  { label: 'Attribute 12', value: 'extensionAttribute12' },
  { label: 'Attribute 13', value: 'extensionAttribute13' }
]

export const ACTIONS_OPTIONS = [
  { label: 'Contains', value: SystemProcessConditionAction.Contains },
  {
    label: 'Always True',
    value: SystemProcessConditionAction.AlwaysTrue
  }
]
